define [], () ->
  name: 'home'
  public: true
  template: require('./home.jade')
  children: [
    name: 'landing', url: '^/',
    template:   require("./landing.jade")
    controller: require("./../home/login/login.coffee")
    params:
      view_app: null
  ,
    name: 'password_reset', url: '^/accounts/password_reset/',
    template: require("./../home/password_reset/password_reset.jade")
    controller: require("./../home/password_reset/password_reset.coffee")
  ,
    name: 'password_reset_confirm', url: '^/accounts/reset/{uidb64}/{token}/',
    template: require("./../home/password_reset_confirm/password_reset_confirm.jade")
    controller: require("./../home/password_reset_confirm/password_reset_confirm.coffee")
  ,
    name: 'password_reset_done', url: '^/accounts/reset/done/',
    template: require("./../home/password_reset_done/password_reset_done.jade")
    controller: require("./../home/password_reset_done/password_reset_done.coffee")
  ,
    name: 'view_sample_application', url: '^/view/sample/'
    public: true
    controller: require("./../home/sample/sample.coffee")
    template: require("./../home/sample/sample.jade")
  ,
    name: 'security', url: '^/security/',
    template: require("./../home/security/security.jade")
  ,
    name: 'applicant_warning_message', url: '^/applicant-warning-message/',
    template: require("./../home/applicant_warning_message/applicant_warning_message.jade")
  ,
    name: 'applicant_ssn', url: '^/applicant-ssn/',
    template: require("./../home/applicant_ssn/applicant_ssn.jade")
  ,
    name: 'how_to_get_verified_for_credit_reports', url: '^/how-to-get-verified-for-credit-reports',
    template: require("./../home/how_to_get_verified_for_credit_reports/how_to_get_verified_for_credit_reports.jade")
  ,
    name: 'privacy', url: '^/privacy/',
    template: require("./../home/privacy/privacy.jade")
    controller: require("./../home/privacy/privacy.coffee")
  ,
    name: 'terms_of_use', url: '^/termsofuse/',
    template: require("./../home/terms_of_use/terms_of_use.jade")
  ,
    name: 'terms_of_use_mp', url: '^/mypayments/termsofuse/',
    template: require("./../home/terms_of_use/terms_of_use_mp.jade")
  ,
    name: 'support', url: '^/support/',
    template: require("./../home/support/support.jade")
  ,
    name: 'applicants', url: '^/applicants/',
    template: require("./../home/applicants/applicants.jade")
  ,
    name: 'report_accuracy', url:'^/report-accuracy/',
    template: require("./../home/about_reports/report_accuracy.jade")
  ,
    name: 'applicant_benefits', url: '^/applicant-benefits/',
    template: require("./../home/applicant_benefits/applicant_benefits.jade")
  ,
    name: 'free_rental_application_pdf', url: '^/free-rental-application-pdf/',
    template: require("./../home/keywords/free_rental_application_pdf.jade")
  ,
    name: '403', template: require("../home/403/403.jade")
  ,
    name: '404', 
    template: require("../home/404/404.jade")
    controller: require("./../home/404/404.coffee")
  ,
    name: '500', template: require("../home/500/500.jade")
  ]



// WEBPACK FOOTER //
// ./components/bare_home/routes.coffee